import React, { ReactElement, useEffect, useState } from 'react'
import { FormMode } from '../../../shared/interfaces'
import { ApiTokenFormAdapter, ApiTokenFormFields } from '../api-token-form/ApiTokenForm.constants'
import ApiTokenForm from '../api-token-form'
import { EditApiTokenProps, EditApiTokenStateProps, IEditApiOwnProps } from './EditApiToken.types'
import { ApiTokenFormValues } from '../api-token-form/ApiTokenForm.types'
import { connect } from 'react-redux'
import { IAppState } from 'core/store/store'
import { change } from 'redux-form'
import { editApiToken, fetchApiById } from '../ApiTokens.actions'
import { fetchPermissions } from 'core/actions/Profile.actions'
import { destroyForm } from 'core/actions/Common'
import { get } from 'lodash-es'
import { withPermissionsHOC } from 'core/hoc/permissionsHoc'
import moment from 'moment'
import { Spinner } from '@digicert/dcone-common-ui'
import history from '../../../core/history/history'
import styles from '../ApiTokens.module.scss'
import { Translate } from 'react-localize-redux'
import { RouterConfig } from '../../../core/utils/constants'

const EditApiToken = (props: EditApiTokenProps): ReactElement => {
  const [isLoading, setLoading] = useState(false)
  const [apiToken, setApiToken] = useState(props.apiTokenValue)
  const { apiTokens, change } = props
  const { destroyForm, fetchApiById, match } = props
  useEffect(() => {
    fetchApiById(match.params.tokenId).then((response: any) => {
      setApiToken(response)
    })
    return () => {
      destroyForm(ApiTokenFormAdapter.name)
    }
  }, [fetchApiById, destroyForm])
  useEffect(() => {
    if (props.apiTokens && props.apiTokens.length < 20) {
      change(ApiTokenFormAdapter.name, ApiTokenFormFields.apiTokens, props.apiTokens)
    }
  }, [apiTokens, change])

  const onCancel = () => {
    history.push(RouterConfig.administrators.details(props.userId))
  }

  const onSubmit = async (values: ApiTokenFormValues): Promise<void> => {
    setLoading(true)
    const payload = {
      name: values.name,
      end_date: values.end_date ? moment.utc(values.end_date).format() : null,
      enabled: true
    }
    await props.editApiToken(match.params.tokenId, payload).then(() => {
      history.goBack()
    })
    setLoading(false)
  }
  if (!apiToken) {
    return <div className='spin-wrap'><Spinner/></div>
  } else {
    return (
      <div className={styles.apiTokenContainer}>
        <h1><Translate id='apiTokens.form.editToken'/> </h1>
        <ApiTokenForm
          onCancel={onCancel}
          mode={FormMode.edit}
          location={props.location}
          onSubmit={onSubmit}
          hash={props.location.hash}
          link={props.match.url}
          isLoading={isLoading}
          destroyForm={props.destroyForm}
          apiToken={props.apiToken}
          apiTokenValue={apiToken}
          userId={props.userId}
        />
      </div>
    )
  }
}
EditApiToken.displayName = 'EditApiToken'

export default connect(
  (state: IAppState, ownProps: IEditApiOwnProps): EditApiTokenStateProps => ({
    apiTokenValue: state.apiTokens.items.find(api => api.id === ownProps.match.params.tokenId),
    apiTokens: state.apiTokens.items,
    allPermissions: get(state, 'profile.permissions', {}),
    userId: state.profile.data !== undefined ?  state.profile.data.id : ''
  }),
  { fetchApiById,
    change,
    fetchPermissions,
    editApiToken,
    destroyForm }
)(withPermissionsHOC(EditApiToken, []))
